import { Token } from '@lumino/coreutils';
/**
 * The token for the settings service.
 */
export const IContents = new Token('@jupyterlite/contents:IContents');
/**
 * Commonly-used mimetypes
 */
export var MIME;
(function (MIME) {
    MIME.JS = 'application/javascript';
    MIME.JSON = 'application/json';
    MIME.MANIFEST_JSON = 'application/manifest+json';
    MIME.PLAIN_TEXT = 'text/plain';
    MIME.PYTHON = 'application/x-python-code';
    MIME.SVG = 'image/svg+xml';
    MIME.XML = 'application/xml';
    /**
     * A list of mime types of common text file types
     */
    MIME.KNOWN_TEXT_TYPES = new Set([
        MIME.JS,
        MIME.JSON,
        MIME.MANIFEST_JSON,
        MIME.PLAIN_TEXT,
        MIME.PYTHON,
        MIME.SVG,
        MIME.XML,
    ]);
    MIME.OCTET_STREAM = 'octet/stream';
})(MIME || (MIME = {}));
